var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { getConfigGeneral } from '../index';
import { getConfigVideo } from '../config-videos';
import { getZonas } from '../config-paginas'; // import { pad3 } from '../../util'

var getContenidoTipoFlashcards = function getContenidoTipoFlashcards(state, zona) {
  var contenido = {
    tipo: 'flashcards',
    flashcards: zona.vinculo
  };
  return contenido;
};

var getContenidoTipoVideo = function getContenidoTipoVideo(state, zona) {
  var videoId = zona.vinculo.split(':')[1]; // zona.vinculo.substring(10);

  var configVideo = getConfigVideo(state, videoId);

  var contenido = _extends({
    tipo: 'video'
  }, configVideo);

  return contenido;
};

var getContenidoTipoHistoria = function getContenidoTipoHistoria(state, zona) {
  var _zona$vinculo$split$ = zona.vinculo.split(':')[1].split('.'),
      numHistoria = _zona$vinculo$split$[0],
      numPaso = _zona$vinculo$split$[1],
      hayBotonTexto = _zona$vinculo$split$[2],
      txtNumVineta = _zona$vinculo$split$[3]; // swf,HISTORIA:3.1.NO.txtNumVineta


  var configGeneral = getConfigGeneral(state);
  var idLibroHistorias = configGeneral.idLibroHistorias; // const numPagina = Number(numHistoria)

  var numZona = zona.numZona || numPaso;
  var vinetas = getZonas(state, idLibroHistorias, Number(numHistoria));
  var contenido = {
    // id: libroId + pad3(numPagina) + '.' + numZona, 
    numZona: numZona,
    tipo: 'historia',
    // libroId,
    // numPagina,
    numHistoria: numHistoria,
    numPaso: numPaso,
    numPasos: vinetas.length,
    hayBotonTexto: hayBotonTexto !== 'NO',
    txtNumVineta: txtNumVineta,
    libroId: idLibroHistorias
  };
  return contenido;
};

var getContenidoTipoSwf = function getContenidoTipoSwf(state, zona) {
  if (zona.vinculo.indexOf('swf,VIDEO') === 0 || zona.vinculo.indexOf('swf,ANIM') === 0) {
    return getContenidoTipoVideo(state, zona);
  }

  if (zona.vinculo.indexOf('swf,HISTORIA') === 0) {
    return getContenidoTipoHistoria(state, zona);
  }

  if (zona.vinculo.indexOf('swf,FLASHCARDS') === 0) {
    return getContenidoTipoFlashcards(state, zona);
  }

  return {
    tipo: zona.vinculo.split(',')[1]
  };
};

export default getContenidoTipoSwf;